// ─── Helpers de construcción de filas ─────────────────────────────────────────

function _crearFilaVoltajeHTML(n, cav) {
    var puntos = ['P1','P2','P3','P4','P5','P6','P7','P8'];
    var dbKeys = ['voltajeP1','voltajeP2','voltajeP3','voltajeP4','voltajeP5','voltajeP6','voltajeP7','voltajeP8'];
    var celdas = '';
    for (var i = 0; i < puntos.length; i++) {
        var nombre = 'voltajeCav' + n + puntos[i] + 'Soplado';
        var val    = (cav && cav[dbKeys[i]] !== undefined && cav[dbKeys[i]] !== null) ? cav[dbKeys[i]] : '';
        celdas += '<td>'
            + '<input class="inputPerfil formatoNumeroDecimal"'
            + ' data-campo="' + puntos[i] + '"'
            + ' name="' + nombre + '"'
            + ' id="' + nombre + '"'
            + ' type="text"'
            + ' value="' + val + '">'
            + '</td>';
    }
    return '<tr>'
        + '<td class="celdaCav">' + n + '</td>'
        + celdas
        + '<td class="celdaEliminarCav">'
        + '<button type="button" class="btnEliminarCavidadPerfil">'
        + '<img src="/public/build/img/icons/papelera.svg" alt="Eliminar" class="artOpePapelera">'
        + '</button>'
        + '</td>'
        + '</tr>';
}

function _crearFilaTiemposHTML(n, cav) {
    var campos = [
        { campo: 'delay',      db: 'delay',            nombre: 'delayCav'      + n + 'Soplado' },
        { campo: 'preSoplado', db: 'tiempoPreSoplado',  nombre: 'preSopladoCav' + n + 'Soplado' },
        { campo: 'soplado',    db: 'tiempoSoplado',     nombre: 'sopladoCav'    + n + 'Soplado' }
    ];
    var celdas = '';
    for (var i = 0; i < campos.length; i++) {
        var val = (cav && cav[campos[i].db] !== undefined && cav[campos[i].db] !== null) ? cav[campos[i].db] : '';
        celdas += '<td>'
            + '<input class="inputPerfil formatoNumeroDecimal"'
            + ' data-campo="' + campos[i].campo + '"'
            + ' name="' + campos[i].nombre + '"'
            + ' id="' + campos[i].nombre + '"'
            + ' type="text"'
            + ' value="' + val + '">'
            + '</td>';
    }
    return '<tr>'
        + '<td class="celdaCav">' + n + '</td>'
        + celdas
        + '<td class="celdaEliminarCav">'
        + '<button type="button" class="btnEliminarCavidadPerfil">'
        + '<img src="/public/build/img/icons/papelera.svg" alt="Eliminar" class="artOpePapelera">'
        + '</button>'
        + '</td>'
        + '</tr>';
}

// ─── Aplicar/quitar bloqueo de edición en el contenedor de perfiles ───────────

window.bloquearPerfilesSoplado = function(bloquear) {
    var contPerfiles = document.getElementById('contPerfilesOperacionSoplado');
    if (!contPerfiles) return;

    // Acciones superiores (guardar + nueva cavidad)
    var accionesPerfiles = contPerfiles.querySelector('.perfilesAcciones');
    if (accionesPerfiles) {
        accionesPerfiles.style.display = bloquear ? 'none' : '';
    }

    // Columna papelera y su cabecera en ambas tablas
    var celdasEliminar = contPerfiles.querySelectorAll('.celdaEliminarCav');
    for (var i = 0; i < celdasEliminar.length; i++) {
        celdasEliminar[i].style.display = bloquear ? 'none' : '';
    }
    var thsUltimos = contPerfiles.querySelectorAll('thead tr th:last-child');
    for (var j = 0; j < thsUltimos.length; j++) {
        thsUltimos[j].style.display = bloquear ? 'none' : '';
    }

    // Todos los inputs del área de perfiles
    var inputs = contPerfiles.querySelectorAll('input');
    for (var k = 0; k < inputs.length; k++) {
        if (bloquear) {
            inputs[k].setAttribute('readonly', 'readonly');
        } else {
            inputs[k].removeAttribute('readonly');
        }
    }
};

// ─── Poblar formulario desde datos del API ─────────────────────────────────────

window.poblarPerfilesSoplado = function(perfilData) {
    var generales = null;
    var cavidades = [];

    if (perfilData) {
        generales = perfilData.generales;
        cavidades = perfilData.cavidades || [];
    }

    var inpTemp  = document.getElementById('temperaturaPirometroSoplado');
    var inpPAlta = document.getElementById('presionAltaSoplado');
    var inpPBaja = document.getElementById('presionBajaSoplado');
    var inpVel   = document.getElementById('velocidadPortapreformasSoplado');

    if (inpTemp)  inpTemp.value  = (generales && generales.temperaturaPirometro  !== null) ? generales.temperaturaPirometro  : '';
    if (inpPAlta) inpPAlta.value = (generales && generales.presionAlta           !== null) ? generales.presionAlta           : '';
    if (inpPBaja) inpPBaja.value = (generales && generales.presionBaja           !== null) ? generales.presionBaja           : '';
    if (inpVel)   inpVel.value   = (generales && generales.velocidadPortapreformas !== null) ? generales.velocidadPortapreformas : '';

    var tbodyV = document.getElementById('tbodyVoltajeSoplado');
    var tbodyT = document.getElementById('tbodyTiemposSoplado');
    if (!tbodyV || !tbodyT) return;

    if (cavidades.length === 0) {
        tbodyV.innerHTML = _crearFilaVoltajeHTML(1, null) + _crearFilaVoltajeHTML(2, null);
        tbodyT.innerHTML = _crearFilaTiemposHTML(1, null) + _crearFilaTiemposHTML(2, null);
        return;
    }

    var htmlV = '';
    var htmlT = '';
    for (var i = 0; i < cavidades.length; i++) {
        var n = i + 1;
        htmlV += _crearFilaVoltajeHTML(n, cavidades[i]);
        htmlT += _crearFilaTiemposHTML(n, cavidades[i]);
    }
    tbodyV.innerHTML = htmlV;
    tbodyT.innerHTML = htmlT;
};

// ─── Guardar perfiles ──────────────────────────────────────────────────────────

document.addEventListener('click', function(e) {
    var btn = e.target.closest('#btnGuardarPerfilesSoplado');
    if (!btn) return;

    var inputIdReporte = document.getElementById('idReporteSoplado');
    if (!inputIdReporte || !inputIdReporte.value) {
        lanzarAlerta('No se identificó el reporte.', 'alerta-roja');
        return;
    }

    var tbodyV = document.getElementById('tbodyVoltajeSoplado');
    if (!tbodyV) return;
    var totalCavidades = tbodyV.querySelectorAll('tr').length;

    var formData = new FormData();
    formData.append('idEncabezadoReporteSoplado',    inputIdReporte.value);
    formData.append('totalCavidadesSoplado',          totalCavidades);

    var idsGenerales = [
        'temperaturaPirometroSoplado',
        'presionAltaSoplado',
        'presionBajaSoplado',
        'velocidadPortapreformasSoplado'
    ];
    for (var g = 0; g < idsGenerales.length; g++) {
        var inpGen = document.getElementById(idsGenerales[g]);
        formData.append(idsGenerales[g], inpGen ? inpGen.value : '');
    }

    var form = document.getElementById('formProduccionSoplado');
    if (form) {
        var perfilesInputs = form.querySelectorAll(
            '#tbodyVoltajeSoplado input[name], #tbodyTiemposSoplado input[name]'
        );
        for (var j = 0; j < perfilesInputs.length; j++) {
            formData.append(perfilesInputs[j].name, perfilesInputs[j].value);
        }
    }

    btn.disabled = true;

    fetch('/api/soplado/guardar-perfiles', {
        method: 'POST',
        body: formData
    })
    .then(function(respuesta) {
        return respuesta.json().then(function(json) {
            return { json: json, status: respuesta.status };
        });
    })
    .then(function(data) {
        var resultado = data.json.result;

        if (data.status !== 200 || !resultado) {
            lanzarAlerta('Error al guardar los perfiles. Contacta al administrador.', 'alerta-roja');
            return;
        }
        if (resultado.hayErrores) {
            var errores = resultado.errores;
            for (var k = 0; k < errores.length; k++) {
                lanzarAlerta(errores[k].mensaje, errores[k].clase);
            }
            return;
        }
        lanzarAlerta(resultado.errores[0].mensaje, resultado.errores[0].clase);
    })
    .catch(function(err) {
        console.error('Error al guardar perfiles:', err);
        lanzarAlerta('Error crítico. Contacta al administrador.', 'alerta-roja');
    })
    .finally(function() {
        btn.disabled = false;
    });
});
